import React, { useState } from 'react';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import Organizations from './components/Organizations';
import Videos from './components/Videos';
import VideoSessions from './components/VideoSessions';
import VRGlasses from './components/VRGlasses';
import Questionnaires from './components/Questionnaires';
import Assessments from './components/Assessments';
import IbsFormSubmissions from './components/IbsFormSubmissions';

function AppContent() {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Login />;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'users':
        return <Users />;
      case 'organizations':
        return <Organizations />;
      case 'videos':
        return <Videos />;
      case 'video-sessions':
        return <VideoSessions />;
      case 'vr-glasses':
        return <VRGlasses />;
      case 'questionnaires':
        return <Questionnaires />;
      case 'assessments':
        return <Assessments />;
      case 'ibs-form-submissions':
        return <IbsFormSubmissions />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="app-layout">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <main className="main-content">
        {renderContent()}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
